import { useQuery } from "@apollo/client";
import { GetStatesDocument } from "../generated/graphql-operations";

export const useGetStateData = (country_id: number) => {
  const states = useQuery(GetStatesDocument, { variables: { country_id } });
  return states;
};
